import { Collapse, Stack } from "@mui/material";
import { type FC, type PropsWithChildren, useState } from "react";
import { ShowAllToggleButton } from "web_myplann/Shared/Components/ShowAllToggleButton";

type Props = {
	showLabel: string;
	hideLabel: string;
	collapsible?: boolean;
};

export const ExtendedParamsDisclosure: FC<PropsWithChildren<Props>> = ({
	showLabel,
	hideLabel,
	collapsible = true,
	children,
}) => {
	const [expanded, setExpanded] = useState(false);

	if (!collapsible) {
		return <>{children}</>;
	}

	return (
		<Stack>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<Stack>{children}</Stack>
			</Collapse>
			<ShowAllToggleButton
				variant="disclosure"
				expanded={expanded}
				onClick={() => setExpanded((prev) => !prev)}
				collapsedLabel={showLabel}
				expandedLabel={hideLabel}
			/>
		</Stack>
	);
};
